import { Component, HostListener } from '@angular/core';
import { AuthService } from './services/auth.service';
import { RouterService } from './services/router.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    public auth: AuthService,
    public routerService: RouterService
  ) { }

  changeOfRoutes(): void {
    this.routerService.updateRoute();
  }

  @HostListener('window:mousedown') refreshUserState() {
    this.auth.resetInactivityTimer()
  }
}
